
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/[section]",
      function () {
        return require("private-next-pages/faq/[section]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/[section]"])
      });
    }
  